import { Component, OnInit } from "@angular/core";
import {
  FormBuilder,
  Validators,
  FormGroup,
  FormArray,
  AbstractControl,
  ValidatorFn,
} from "@angular/forms";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ToastrService } from "ngx-toastr";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { DataService } from "src/app/shared/Services/data.service";

@Component({
  selector: "app-program-list",
  templateUrl: "./program-list.component.html",
  styleUrls: ["./program-list.component.scss"],
})
export class ProgramListComponent implements OnInit {
  breadCrumbItems: Array<{}>;
  isChecked: boolean = false;
  issecChecked: boolean = false;
  programData: any = [];
  errmsg: string = "";
  searchTerm: any = "";
  validationform: FormGroup;
  operationData: FormArray;
  editProgId;
  action: any;
  currentPage = 1;
  itemsPerPage = 10;
  pageSize;
  submitted: boolean = false;
  pages: any;
  delprogramId = "";
  user: any;
  custId: any;
  fixedCostData: any = [];
  variableCostData: any = [];
  configCost: any = [];
  operationTempData: any;
  settings = {};
  hoursArray = Array.from({ length: 24 }, (_, i) => i + 1); // [1, 2, ..., 24]
  private destroy$ = new Subject<void>();
  processData:any=[]
  constructor(
    private modalService: NgbModal,
    public formBuilder: FormBuilder,
    private dataservice: DataService,
    private toastr: ToastrService
  ) {}

  ngOnInit(): void {
    this.settings = {
      singleSelection: false,
      idField: "item_id",
      textField: "item_text",
      selectAllText: "Select All",
      unSelectAllText: "Unselect All",
      itemsShowLimit: 3,
      allowSearchFilter: true,
    };
    this.user = JSON.parse(sessionStorage.getItem("currentUser"));
    this.custId = this.user["user"]["custId"];
    this.breadCrumbItems = [
      { label: "Configuration" },
      { label: "Job Cards", active: true },
    ];
    this.getProcessData()
    this.getProgramData();
    this.getCost();
  }

  getProcessData(){
      this.dataservice
           .get(`api/process?custId=${this.custId}`)
           .pipe(takeUntil(this.destroy$))
           .subscribe(
             (res: any) => {
               this.processData = res
             },
             (err) => {
               this.toastr.error('Server Unreachable');
               this.errmsg = 'Failed to load processes.';
             }
           );
  }
  // ─── STATIC VALIDATOR (no 'this' context issue) ───────────────────────────
  nonNegativeValidator: ValidatorFn = (control: AbstractControl) => {
    const value = control.value;
    if (value !== null && value !== "" && value !== undefined) {
      const num = Number(value);
      if (isNaN(num)) return { required: true };
      if (num < 0) return { negativeValue: true };
      if (String(value).includes(".")) return { decimalNotAllowed: true };
    }
    return null;
  };

  // ─── API CALLS ─────────────────────────────────────────────────────────────
  getCost() {
    this.dataservice.get("api/cost").subscribe(
      (res: any) => {
        this.toastr.clear();
        this.configCost = res || [];
        this.selectType(this.configCost);
      },
      (error) => {
        this.toastr.error("Server Unreachable");
        this.configCost = [];
      }
    );
  }

  selectType(data) {
    data.forEach((elm, index) => {
      if ("fixed" == elm["costType"]) {
        if (elm.costName != "EnergyCost") {
          this.fixedCostData.push({ item_id: index, item_text: `${elm.costName}` });
        }
      } else if ("variable" == elm["costType"]) {
        this.variableCostData.push({ item_id: index, item_text: `${elm.costName}` });
      }
    });
  }

  getProgramData() {
    this.dataservice.get("programName/masterList/" + this.custId).subscribe(
      (res) => {
        if (res) this.programData = res["result"];
      },
      (error: any) => {
        this.errmsg = "Server Unreachable";
      }
    );
  }

  // ─── INPUT HANDLERS ────────────────────────────────────────────────────────
  onPartNameInput(event: Event): void {
    const input = (event.target as HTMLInputElement).value;
    const sanitized = input.replace(/-/g, "");
    this.validationform.get("partName")?.setValue(sanitized, { emitEvent: false });
  }

  // ─── FORM INIT ─────────────────────────────────────────────────────────────
  initializeForm() {
    const existingOperationData = this.validationform?.get("operationData") as FormArray;
    if (existingOperationData) {
      while (existingOperationData.length !== 0) {
        existingOperationData.removeAt(0);
      }
    }

    const commonFields = {
      programId:    [this.validationform?.value?.programId    || "", [Validators.required]],
      programName:  [this.validationform?.value?.programName  || "", [Validators.required]],
      countingType: [this.validationform?.value?.countingType || "partsPerCycle", [Validators.required]],
      partName:     [this.validationform?.value?.partName     || "", [Validators.required]],
      partsPerCycle:[this.validationform?.value?.partsPerCycle|| "", [Validators.required, this.nonNegativeValidator]],
      operatorCost: [this.validationform?.value?.operatorCost || ""],
      operationData: this.formBuilder.array([], Validators.required),
    };

    if (this.isChecked && !this.issecChecked) {
      this.validationform = this.formBuilder.group({
        ...commonFields,
        fixedCosts:    [this.validationform?.value?.fixedCosts    || ""],
        variableCosts: [this.validationform?.value?.variableCosts || ""],
      });
    } else if (this.isChecked && this.issecChecked) {
      this.validationform = this.formBuilder.group({
        ...commonFields,
        fixedCostss:    [this.validationform?.value?.fixedCostss    || ""],
        variableCostss: [this.validationform?.value?.variableCostss || ""],
      });
    } else {
      this.validationform = this.formBuilder.group({
        ...commonFields,
        fixedCost:    [this.validationform?.value?.fixedCost    || ""],
        variableCost: [this.validationform?.value?.variableCost || ""],
      });
    }

    this.addOperation();
  }

  // ─── OPERATIONS ────────────────────────────────────────────────────────────
  // addOperation() {
  //   const arrayControl = this.validationform.get("operationData") as FormArray;

  //   if (this.isChecked) {
  //     if (!this.issecChecked) {
  //       arrayControl.push(
  //         this.formBuilder.group({
  //           operationId:       [Math.floor(Math.random() * 900000) + 1, Validators.required],
  //           operationName:     ["", [Validators.required, this.nonNegativeValidator]],
  //           runningTime:       ["", [Validators.required, this.nonNegativeValidator]],
  //           loadingTime:       ["", [Validators.required, this.nonNegativeValidator]],
  //           unloadingTime:     ["", [Validators.required, this.nonNegativeValidator]],
  //           standardSetupTime: ["", [Validators.required, this.nonNegativeValidator]],
  //         })
  //       );
  //     } else {
  //       arrayControl.push(
  //         this.formBuilder.group({
  //           operationId:       [Math.floor(Math.random() * 900000) + 1, Validators.required],
  //           operationName:     ["", [Validators.required, this.nonNegativeValidator]],
  //           runningTime:       ["", [Validators.required, this.nonNegativeValidator]],
  //           loadingTime:       ["", [Validators.required, this.nonNegativeValidator]],
  //           unloadingTime:     ["", [Validators.required, this.nonNegativeValidator]],
  //           standardSetupTime: ["", [Validators.required, this.nonNegativeValidator]],
  //           sequenceData:      this.formBuilder.array([], Validators.required),
  //         })
  //       );
  //       this.addSequenceOperation(arrayControl.length - 1);
  //     }
  //   } else {
  //     arrayControl.push(
  //       this.formBuilder.group({
  //         operationId:   [Math.floor(Math.random() * 900000) + 1, Validators.required],
  //         operationName: ["", [Validators.required, this.nonNegativeValidator]],
  //         target:        ["", [Validators.required, this.nonNegativeValidator]],
  //         targetHours:   ["", Validators.required], 
  //       })
  //     );
  //   }
  // }

  addOperation() {
  const arrayControl = this.validationform.get('operationData') as FormArray;
  let newGroup: FormGroup;

  if (this.isChecked) {
    if (!this.issecChecked) {
      newGroup = this.formBuilder.group({
        operationId:       [Math.floor(Math.random() * 900000) + 1, Validators.required],
        operationName:     ['', [Validators.required, this.nonNegativeValidator]],
        processName:       [''                                                  ],
        runningTime:       ['', [Validators.required, this.nonNegativeValidator]],
        loadingTime:       ['', [Validators.required, this.nonNegativeValidator]],
        unloadingTime:     ['', [Validators.required, this.nonNegativeValidator]],
        standardSetupTime: ['', [Validators.required, this.nonNegativeValidator]],
      });
    } else {
      newGroup = this.formBuilder.group({
        operationId:       [Math.floor(Math.random() * 900000) + 1, Validators.required],
        operationName:     ['', [Validators.required, this.nonNegativeValidator]],
        processName:       [''                                                  ],
        runningTime:       ['', [Validators.required, this.nonNegativeValidator]],
        loadingTime:       ['', [Validators.required, this.nonNegativeValidator]],
        unloadingTime:     ['', [Validators.required, this.nonNegativeValidator]],
        standardSetupTime: ['', [Validators.required, this.nonNegativeValidator]],
        sequenceData:      this.formBuilder.array([], Validators.required),
      });
    }
  } else {
    newGroup = this.formBuilder.group({
      operationId:   [Math.floor(Math.random() * 900000) + 1, Validators.required],
      processName:   [''                                                  ],
      operationName: ['', [Validators.required, this.nonNegativeValidator]],
      target:        ['', [Validators.required, this.nonNegativeValidator]],
      targetHours:   ['', Validators.required],
    });
  }

  // ── Subscribe BEFORE pushing ──
  newGroup.get('operationName')?.valueChanges.subscribe(() => {
    this.checkDuplicateOperationName();
  });

  arrayControl.push(newGroup);

  if (this.isChecked && this.issecChecked) {
    this.addSequenceOperation(arrayControl.length - 1);
  }
}

  // removeOperation(index: number) {
  //   const arrayControl = this.validationform.get("operationData") as FormArray;
  //   arrayControl.removeAt(index);
  // }

  removeOperation(index: number) {
  const arrayControl = this.validationform.get('operationData') as FormArray;
  arrayControl.removeAt(index);
  this.checkDuplicateOperationName(); // ← add this
}

  // ─── SEQUENCES ─────────────────────────────────────────────────────────────
  addSequenceOperation(operationIndex: number) {
    const operationArray = this.validationform.get("operationData") as FormArray;
    const operationGroup = operationArray.at(operationIndex) as FormGroup;
    const sequenceArray  = operationGroup.get("sequenceData") as FormArray;

    const sequenceGroup = this.formBuilder.group({
      seqNumber:   ["", Validators.required],
      runningTime: ["", [Validators.required, this.nonNegativeValidator]],
    });

    sequenceGroup.get("runningTime")?.valueChanges.subscribe(() => {
      this.calculateTotalRuntime(operationIndex);
    });

    sequenceArray.push(sequenceGroup);
    this.calculateTotalRuntime(operationIndex);
  }

  removeSequence(operationIndex: number, sequenceIndex: number) {
    const operationArray = this.validationform.get("operationData") as FormArray;
    const sequenceArray  = (operationArray.at(operationIndex) as FormGroup).get("sequenceData") as FormArray;
    sequenceArray.removeAt(sequenceIndex);
    this.calculateTotalRuntime(operationIndex);
  }

  calculateTotalRuntime(operationIndex: number) {
    const operationArray = this.validationform.get("operationData") as FormArray;
    const operationGroup = operationArray.at(operationIndex) as FormGroup;
    const sequenceArray  = operationGroup.get("sequenceData") as FormArray;

    const total = sequenceArray.controls.reduce((sum, seq) => {
      return sum + (Number(seq.get("runningTime")?.value) || 0);
    }, 0);

    operationGroup.get("runningTime")?.patchValue(total, { emitEvent: false });
  }

  // ─── MODAL HELPERS ─────────────────────────────────────────────────────────
  get form() {
    return this.validationform.controls;
  }

  onCheckboxChange(e) {
    if (this.action == "Add") this.initializeForm();
  }

  onsecCheckboxChange(e) {
    if (this.action == "Add") this.initializeForm();
  }

  openModal(content: any, data: any, act: any) {
    this.action    = act;
    this.submitted = false;

    if (act === "Add") {
      this.isChecked    = false;
      this.issecChecked = false;
      this.initializeForm();
    } else if (act === "Edit") {
      this.isChecked    = !!data["isCycleTime"];
      this.issecChecked = data["operationData"]?.some(
        (op: any) => op.sequenceData && op.sequenceData.length > 0
      );

      if (data) {
        this.editProgId = data.id;
        this.initializeForm();
        this.pathValue(this.validationform, data);
        ["programId", "programName", "partName"].forEach((key) =>
          this.validationform.get(key)?.disable()
        );
      }
    }

    this.modalService.open(content, { backdrop: "static", centered: true, size: "lg" });
  }

  openModalDelete(deletetemp, data) {
    this.delprogramId = data.id;
    this.modalService.open(deletetemp, { backdrop: "static", centered: true });
  }

  openModalOperation(temp, data) {
    if (data["operationData"].length != 0) {
      this.operationTempData = data["operationData"];
      this.modalService.open(temp, { backdrop: "static", centered: true, size: "lg" });
    }
  }

  // ─── PATCH VALUES ──────────────────────────────────────────────────────────
  createSequenceGroup(operationIndex: number, data?: any): FormGroup {
    const group = this.formBuilder.group({
      seqNumber:   [data ? data.seqNumber || data.sequenceId : "", Validators.required],
      runningTime: [data ? data.runningTime : "",                  [Validators.required, this.nonNegativeValidator]],
    });

    group.get("runningTime")?.valueChanges.subscribe(() => {
      this.calculateTotalRuntime(operationIndex);
    });

    return group;
  }

  // pathValue(formGroup: FormGroup, data: any): void {
  //   const controls = formGroup.controls;

  //   for (const key in controls) {
  //     if (key === "fixedCosts" || key === "fixedCostss") {
  //       controls[key].patchValue(data["fixedCost"]);
  //     } else if (key === "variableCosts" || key === "variableCostss") {
  //       controls[key].patchValue(data["variableCost"]);
  //     } else if (key === "operationData" && Array.isArray(data["operationData"])) {
  //       const operationArray = controls["operationData"] as FormArray;
  //       operationArray.clear();

  //       data["operationData"].forEach((op: any, index: number) => {
  //         let operationGroup: FormGroup;

  //         if (this.isChecked && this.issecChecked) {
  //           const sequenceArray = this.formBuilder.array([]);
  //           if (op.sequenceData?.length) {
  //             op.sequenceData.forEach((seq: any) => {
  //               sequenceArray.push(this.createSequenceGroup(index, seq));
  //             });
  //           }
  //           operationGroup = this.formBuilder.group({
  //             operationId:       [op.operationId,       Validators.required],
  //             operationName:     [op.operationName,     [Validators.required, this.nonNegativeValidator]],
  //             loadingTime:       [op.loadingTime,       [Validators.required, this.nonNegativeValidator]],
  //             unloadingTime:     [op.unloadingTime,     [Validators.required, this.nonNegativeValidator]],
  //             standardSetupTime: [op.standardSetupTime, [Validators.required, this.nonNegativeValidator]],
  //             runningTime:       [op.runningTime || 0],
  //             sequenceData:      sequenceArray,
  //           });
  //         } else if (this.isChecked && !this.issecChecked) {
  //           operationGroup = this.formBuilder.group({
  //             operationId:       [op.operationId,       Validators.required],
  //             operationName:     [op.operationName,     [Validators.required, this.nonNegativeValidator]],
  //             runningTime:       [op.runningTime,       [Validators.required, this.nonNegativeValidator]],
  //             loadingTime:       [op.loadingTime,       [Validators.required, this.nonNegativeValidator]],
  //             unloadingTime:     [op.unloadingTime,     [Validators.required, this.nonNegativeValidator]],
  //             standardSetupTime: [op.standardSetupTime, [Validators.required, this.nonNegativeValidator]],
  //           });
  //         } else {
  //           operationGroup = this.formBuilder.group({
  //             operationId:   [op.operationId,   Validators.required],
  //             operationName: [op.operationName, [Validators.required, this.nonNegativeValidator]],
  //             target:        [op.target,        [Validators.required, this.nonNegativeValidator]],
  //             targetHours:   [op.targetHours || "", Validators.required],
  //           });
  //         }

  //         operationArray.push(operationGroup);
  //         if (this.isChecked && this.issecChecked) {
  //           this.calculateTotalRuntime(index);
  //         }
  //       });
  //     } else {
  //       controls[key]?.patchValue(data[key]);
  //     }
  //   }
  // }

  pathValue(formGroup: FormGroup, data: any): void {
  const controls = formGroup.controls;

  for (const key in controls) {
    if (key === "fixedCosts" || key === "fixedCostss") {
      controls[key].patchValue(data["fixedCost"]);
    } else if (key === "variableCosts" || key === "variableCostss") {
      controls[key].patchValue(data["variableCost"]);
    } else if (key === "operationData" && Array.isArray(data["operationData"])) {
      const operationArray = controls["operationData"] as FormArray;
      operationArray.clear();

      data["operationData"].forEach((op: any, index: number) => {
        let operationGroup: FormGroup;

        if (this.isChecked && this.issecChecked) {
          const sequenceArray = this.formBuilder.array([]);
          if (op.sequenceData?.length) {
            op.sequenceData.forEach((seq: any) => {
              sequenceArray.push(this.createSequenceGroup(index, seq));
            });
          }
          operationGroup = this.formBuilder.group({
            operationId:       [op.operationId,       Validators.required],
            operationName:     [op.operationName,     [Validators.required, this.nonNegativeValidator]],
            processName:       [op.processName                                                        ],
            loadingTime:       [op.loadingTime,       [Validators.required, this.nonNegativeValidator]],
            unloadingTime:     [op.unloadingTime,     [Validators.required, this.nonNegativeValidator]],
            standardSetupTime: [op.standardSetupTime, [Validators.required, this.nonNegativeValidator]],
            runningTime:       [op.runningTime || 0],
            sequenceData:      sequenceArray,
          });
        } else if (this.isChecked && !this.issecChecked) {
          operationGroup = this.formBuilder.group({
            operationId:       [op.operationId,       Validators.required],
            operationName:     [op.operationName,     [Validators.required, this.nonNegativeValidator]],
            processName:       [op.processName                                                        ],
            runningTime:       [op.runningTime,       [Validators.required, this.nonNegativeValidator]],
            loadingTime:       [op.loadingTime,       [Validators.required, this.nonNegativeValidator]],
            unloadingTime:     [op.unloadingTime,     [Validators.required, this.nonNegativeValidator]],
            standardSetupTime: [op.standardSetupTime, [Validators.required, this.nonNegativeValidator]],
          });
        } else {
          operationGroup = this.formBuilder.group({
            operationId:   [op.operationId,   Validators.required],
            operationName: [op.operationName, [Validators.required, this.nonNegativeValidator]],
            processName:   [op.processName                                                    ],
            target:        [op.target,        [Validators.required, this.nonNegativeValidator]],
            targetHours:   [op.targetHours || "", Validators.required],
          });
        }

        // ── ADD THIS: subscribe so duplicate check works in Edit mode too ──
        operationGroup.get('operationName')?.valueChanges.subscribe(() => {
          this.checkDuplicateOperationName();
        });

        operationArray.push(operationGroup);

        if (this.isChecked && this.issecChecked) {
          this.calculateTotalRuntime(index);
        }
      });

      // ── ADD THIS: run initial duplicate check after all rows are loaded ──
      this.checkDuplicateOperationName();

    } else {
      controls[key]?.patchValue(data[key]);
    }
  }
}

  getPerPartCycleTime(index: number): string {
    const operationArray = this.validationform.get('operationData') as FormArray;
    const group = operationArray.at(index);
    const target = Number(group.get('target')?.value);
    const hours  = Number(group.get('targetHours')?.value);

    if (target > 0 && hours > 0) {
      const totalSeconds = hours * 3600;
      const cycleTime = totalSeconds / target;
      return cycleTime.toFixed(0);
    }
    return '';
  }

  // ─── PAGINATION ────────────────────────────────────────────────────────────
  onPageChange(pageNum: number): void {
    this.pageSize = this.itemsPerPage * (pageNum - 1);
  }

  // ─── SAVE ──────────────────────────────────────────────────────────────────
  saveData() {
    this.submitted = true;

    if (this.validationform.valid) {
      ["programId", "programName", "partName"].forEach((key) =>
        this.validationform.get(key)?.enable()
      );

      this.pages = {
        custId:        this.custId,
        programId:     this.validationform.value.programId,
        programName:   this.validationform.value.programName,
        partName:      this.validationform.value.partName,
        countingType:  this.validationform.value.countingType,
        partsPerCycle: this.validationform.value.partsPerCycle,
        operatorCost:  this.validationform.value.operatorCost,
        operationData: this.validationform.value.operationData,
        isCycleTime:   this.isChecked,
        isSecCycleTime:this.issecChecked,
      };

      if (this.isChecked && !this.issecChecked) {
        this.pages["fixedCost"]    = this.validationform.value.fixedCosts;
        this.pages["variableCost"] = this.validationform.value.variableCosts;
      } else if (this.isChecked && this.issecChecked) {
        this.pages["fixedCost"]    = this.validationform.value.fixedCostss;
        this.pages["variableCost"] = this.validationform.value.variableCostss;
      } else {
        this.pages["fixedCost"]    = this.validationform.value.fixedCost;
        this.pages["variableCost"] = this.validationform.value.variableCost;
      }

      if (this.action === "Add") {
        this.dataservice.post("programName/masterList", this.pages).subscribe({
          next: (data) => {
            if (data) {
              this.cancel();
              this.toastr.success("Program Added Successfully");
              this.getProgramData();
            }
          },
          error: (err) => this.toastr.error(err.message),
        });
      } else if (this.action === "Edit") {
        this.dataservice.put("programName/masterList/" + this.editProgId, this.pages).subscribe({
          next: (res) => {
            if (res) {
              this.cancel();
              this.toastr.success("Program Updated Successfully");
              this.getProgramData();
            }
          },
          error: (err) => this.toastr.error(err.message),
        });
      }
    } else {
      // Mark all controls as touched so errors show inline
      this.validationform.markAllAsTouched();

      const invalidFields: string[] = [];
      for (const name in this.validationform.controls) {
        if (this.validationform.controls[name].invalid) {
          invalidFields.push(name);
        }
      }
      this.toastr.info(`Please fill all the fields: ${invalidFields.join(", ")}`, "Info");
    }
  }

  // ─── DUPLICATE OPERATION NAME VALIDATOR ───────────────────────────────────
checkDuplicateOperationName(): void {
  const operationArray = this.validationform.get('operationData') as FormArray;
  const names = operationArray.controls.map(c => 
    String(c.get('operationName')?.value).trim().toLowerCase()
  );

  operationArray.controls.forEach((control, index) => {
    const nameControl = control.get('operationName');
    const currentName = String(nameControl?.value).trim().toLowerCase();
    const isDuplicate = currentName !== '' && 
                        names.some((n, i) => i !== index && n === currentName);

    if (isDuplicate) {
      nameControl?.setErrors({ ...nameControl.errors, duplicateName: true });
    } else {
      if (nameControl?.hasError('duplicateName')) {
        const errors = { ...nameControl.errors };
        delete errors['duplicateName'];
        nameControl.setErrors(Object.keys(errors).length ? errors : null);
      }
    }
  });
}

  // ─── CANCEL / DELETE ───────────────────────────────────────────────────────
  cancel() {
    this.submitted = false;
    this.action    = "";
    (this.validationform.get("operationData") as FormArray).clear();
    this.validationform.reset();
    this.modalService.dismissAll();
  }

  delete(id) {
    this.dataservice.delete("programName/masterList/" + id).subscribe((res) => {
      if (res) {
        this.toastr.success("Program deleted Successfully");
        this.modalService.dismissAll();
        this.getProgramData();
      }
    });
  }
}